export default __webpack_public_path__ + "static/media/SPLF.2e01461b.svg";